<script>
import Cover from './Cover.vue'
import Btn from './Btn.vue'
export default {
    components: {
        Cover,
        Btn
    },
    props: {
        width: {
            type: [String, Number],
            default: 349
        },
        title: String,
        simple: Boolean,
        btnText: {
            type: String,
            default: '确定'
        },
        hideClose: Boolean
    },
    computed: {
        styleWidth() {
            return parseInt(this.width) + 'px'
        },
        style() {
            return {
                width: this.styleWidth,
                paddingTop: `${this.simple?48:28}px`
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        confirm() {
            this.$emit('confirm')
        }
    }
}
</script>

<template>
    <Cover>
        <div class="Dialog" :style="style" >
            <img v-if="!hideClose" class="close" @click="close" src="./assets/clear_close.svg">
            <h1>{{title}}</h1>
            <slot>
                <div class="holder" ></div>
            </slot>
            <Btn @click="confirm" >{{btnText}}</Btn>
        </div>
    </Cover>
</template>


<style lang="scss" scoped>
.Dialog {
    background-color: #fff;
    border-radius: 12px;
    padding-bottom: 31px;
    position: relative;
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
    >h1 {
        font-size: 16px;
        text-align: center;
        color: #343434;
        margin-bottom: 23px;
    }
    >.Btn {
        margin-left: 21px;
        margin-right: 21px;
        height: 48px;
        border-radius: 3px;
    }
    .holder {
        height: 12px;
    }
}
</style>




// WEBPACK FOOTER //
// yotta-vue-components/vision/ProductinDiaLog.vue